export const columns = [
    {
        prop: "orderId",
        label: "订单id",
    },
    {
        prop: "userName",
        label: "订单用户",
    },
    {
        prop: "orderStatusStr",
        label: "订单状态",
    },
    {
        prop: "memberStr",
        label: "会员类型",
    },
    {
        prop: "orderFee",
        label: "订单金额",
    },
    {
        prop: "orderCreateTime",
        label: "订单创建时间",
        width: "160",
    },
    {
        prop: "invoiceTypeStr",
        label: "发票类型",
    },
    {
        prop: "invoiceHeader",
        label: "发票抬头",
    },
    {
        prop: "taxpayerIdentifyNumber",
        label: "纳税人识别号",
        width: "160",
    },
    {
        prop: "bankDeposit",
        label: "开户行",
    },
    {
        prop: "bankNumber",
        label: "开户账号",
    },
    {
        prop: "remark",
        label: "备注",
    },
    {
        prop: "receiveEmail",
        label: "接收邮箱",
    },
    {
        prop: "invoiceStatusStr",
        label: "发票状态",
    },
    {
        prop: "invoiceTime",
        label: "开票时间",
        width: "160",
    },
    {
        prop: "invoiceCreateTime",
        label: "开票申请时间",
        width: "160",
    },
    {
        label: "操作",
        slot: "operate",
    },
];
